import { Dialog } from "@themes/pollinator/ui/Dialog";
import { Loader } from "@themes/pollinator/ui/Loader";
import { TimezoneOption } from "@core/features/timezones";
import { Meeting } from "@platform/types/platform.types";
import { ProgramCalendarEventList } from "../../components/ProgramCalendarEventList";

export type Props = {
  meetings?: Meeting[];
  isOpen: boolean;
  onClose: () => void;
  userTimezone?: TimezoneOption;
  onAddCalendarEvent: (
    eventId: number | string | "all",
    calendarType: "google" | "ical"
  ) => void;
};

export function ProgramAddCalendarEventsDialog({
  meetings,
  userTimezone,
  isOpen = true,
  onClose,
  onAddCalendarEvent,
}: Props) {
  return (
    <Dialog
      title="Add Meetings to Calendar"
      isOpen={isOpen}
      onClose={onClose}
      containerClassName="pb-4"
      size="2xl"
    >
      {meetings ? (
        <ProgramCalendarEventList
          meetings={meetings}
          userTimezone={userTimezone}
          onAddCalendarEvent={onAddCalendarEvent}
        />
      ) : (
        <Loader isAbsolute />
      )}
    </Dialog>
  );
}

export default ProgramAddCalendarEventsDialog;

